import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Movie } from '../shared/movie.model'

@Component({
    moduleId: module.id,
    selector: 'cm-movie-ticket',
    templateUrl: 'movie-ticket.component.html',
    styleUrls: ['movie-ticket.component.css']
})
export class MovieTicketComponent implements OnInit {
    @Input() title: string
    @Input() banner: string
    @Input() duration: number
    @Input() rating: number
    @Input() durationSuffix: boolean

    @Output() invite = new EventEmitter<Movie>()

    isTearOffStarted = false
    isTearOffComplete = false

    constructor() { }

    ngOnInit() { }

    getBannerUrl(url) {
        if (!url.startsWith('http://')) {
            url = 'http://developer.tmsimg.com/' + url + '?api_key=9h6jvc6de4ez8xwy53khs5bw'
        }

        return url
    }

    onInvite() {
        this.isTearOffComplete = true
        this.invite.emit()
    }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/movies/movie-ticket/movie-ticket.component.ts